module.exports = __webpack_public_path__ + "media/icons/icon_time-d6ddf6db.png";